import { useEffect, useState } from "react";
import { apiService } from "../services/api";

/**
 * Venda de novas assinaturas aberta? Vem do pricing público do backend
 * (`salesOpen`, ligado a WEEDY_NEW_SALES_CLOSED). `null` enquanto carrega;
 * se a chamada falhar, assume aberto — o backend barra a compra de qualquer jeito.
 */
export function useSalesOpen(): boolean | null {
  const [open, setOpen] = useState<boolean | null>(null);
  useEffect(() => {
    apiService
      .getSubscriptionPricing()
      .then((p) => setOpen(p.salesOpen !== false))
      .catch(() => setOpen(true));
  }, []);
  return open;
}
